import {Component, Input} from '@angular/core';
import {MatTooltip} from "@angular/material/tooltip";
import {SharedPipesModule} from "../../shared/modules/shared-pipes.module";

import {StringDatePipe} from "../../shared/pipes";

@Component({
    selector: 'src-pretty-date',
    templateUrl: './pretty-date.component.html',
    styleUrls: ['./pretty-date.component.scss'],
    imports: [
        MatTooltip,
        SharedPipesModule,
        StringDatePipe
    ]
})
export class PrettyDateComponent {
    /**
     * ISO Formatted date string.
     */
    @Input()
    value: string;
}
